module.exports = __webpack_public_path__ + "img/pc_banner_privacy.4c60ab65.jpeg";